import {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionRoot,
  AccordionTrigger,
} from "../../../accordion/Accordion";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../util/table";
import { ModalProvider } from "../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../Table/TableBasic";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";
import { useState } from "react";
import useActiveColumns from "../../../../hooks/useActiveColumns";
import IngenRegistreringer from "../../../pages/person/id/IngenRegistreringer";
import OpretNyButtonBlock from "../../../pages/person/id/OpretNyButtonBlock";
import { useQuery } from "@tanstack/react-query";
import { get } from "../../../../api/util";
import { SortBy } from "../../../../interfaces/table";
import { orderBy } from "../../../../util/orderBy";
import { defaultUdvalgColumns } from "../../../../config/admin/columnsConfig";
import { adminUdvalgFormConfig } from "../../../../config/form/admin/adminUdvalgFormConfig";

interface Props {
  canWrite: boolean;
}

const defaultSortBy: SortBy<UdvalgFields>[] = [
  {
    direction: "asc",
    field: "navn",
  },
];

const Udvalg = ({ canWrite }: Props) => {
  const [sortBy, setSortBy] = useState<SortBy[]>(defaultSortBy);
  const [activeColumns, setActiveColumns] = useActiveColumns(
    `admin-kodelister-udvalg-active-columns`,
    defaultUdvalgColumns,
  );
  const { data, isPending, error, refetch } = useQuery<IInteresser[]>({
    queryKey: ["udvalg"],
    queryFn: async function () {
      return get({ query: `udvalg` });
    },
  });
  if (error) return <span>Der opstod en fejl</span>;
  if (isPending) return <span>Henter udenlandske avokatsamfund"],...</span>;
  if (!data) {
    return (
      <IngenRegistreringer
        invalidateData={refetch}
        editConfig={canWrite ? adminUdvalgFormConfig(undefined) : undefined}
      />
    );
  }

  return (
    <AccordionRoot>
      <AccordionItem value={"Udvalg"} className="" isEmpty={false}>
        <AccordionHeader>
          <AccordionTrigger className="ps-3">
            <span>Udvalg</span>
          </AccordionTrigger>
        </AccordionHeader>
        <AccordionContent className="c-card c-card--accordion mb-4">
          <ModalProvider>
            <TableRoot>
              <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
                <>
                  {getHeaderActiveColumns(activeColumns, {
                    defaultSortBy,
                    setSortBy,
                    sortBy,
                  })}
                </>
              </TableHead>
              <TableBody>
                {orderBy(
                  data,
                  sortBy.map((s) => s.field),
                  sortBy.map((s) => s.direction),
                ).map((rowData, i) => {
                  return (
                    <TableRow
                      key={i}
                      editConfig={
                        canWrite ? adminUdvalgFormConfig(rowData.id) : undefined
                      }
                      invalidateData={refetch}
                    >
                      <>
                        {activeColumns.map((col) => {
                          return (
                            <TD key={col.field} col={col} rowData={rowData} />
                          );
                        })}
                      </>
                    </TableRow>
                  );
                })}
              </TableBody>
            </TableRoot>
            <ColumnEditorModal
              defaultColumns={defaultUdvalgColumns}
              columns={activeColumns}
              setActiveColumns={setActiveColumns}
            />
            <OpretNyButtonBlock
              editConfig={
                canWrite ? adminUdvalgFormConfig(undefined) : undefined
              }
              invalidateData={refetch}
            />
          </ModalProvider>
        </AccordionContent>
      </AccordionItem>
    </AccordionRoot>
  );
};
export default Udvalg;
